import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const gpi = '/api/general/'
const api = '/api/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const GetCampuses = createAsyncThunk('campuses', (_, thunkAPI) =>
  handleRequest(get(`${gpi}campuses-list`), thunkAPI)
)

export const OtherCampuses = createAsyncThunk('other-campuses', (_, thunkAPI) =>
  handleRequest(get(`${gpi}other-campuses`), thunkAPI)
)

export const OtherCampusPro = createAsyncThunk('other-campus-pros', (id: string, thunkAPI) =>
  handleRequest(get(`${gpi}other-campus-programs/${id}`), thunkAPI)
)

export const ScoreScales = createAsyncThunk('score-scales', (_, thunkAPI) =>
  handleRequest(get(`${gpi}score-scales`), thunkAPI)
)

export const StartImpersonate = createAsyncThunk('impersonate', (data: {}, thunkAPI) =>
  handleRequest(post(`${gpi}start-impersonate`, data), thunkAPI)
)

export const StopImpersonate = createAsyncThunk('stop-impersonate', (data: {}, thunkAPI) =>
  handleRequest(post(`${gpi}stop-impersonate`, data), thunkAPI)
)

export const GetSections = createAsyncThunk('sections', (_, thunkAPI) =>
  handleRequest(get(`${gpi}sections-list`), thunkAPI)
)

export const GetProgramLevels = createAsyncThunk('program-levels', (_, thunkAPI) =>
  handleRequest(get(`${gpi}program-levels-list`), thunkAPI)
)

export const ProgramLevels = createAsyncThunk('pro-levels', (_, thunkAPI) =>
  handleRequest(get(`${gpi}program-levels`), thunkAPI)
)

export const GetProgramYears = createAsyncThunk('pro-years', (_, thunkAPI) =>
  handleRequest(get(`${gpi}program-years-list`), thunkAPI)
)

export const GetPrograms = createAsyncThunk('programs', (_, thunkAPI) =>
  handleRequest(get(`${gpi}programs-list`), thunkAPI)
)

export const GetGenders = createAsyncThunk('genders', (_, thunkAPI) =>
  handleRequest(get(`${gpi}genders-list`), thunkAPI)
)

export const GetCountries = createAsyncThunk('countries', (_, thunkAPI) =>
  handleRequest(get(`${gpi}countries-list`), thunkAPI)
)

export const GetCourses = createAsyncThunk('courses', (_, thunkAPI) =>
  handleRequest(get(`${gpi}courses-list`), thunkAPI)
)

export const GetRegulationCategories = createAsyncThunk('regulation-cats', (_, thunkAPI) =>
  handleRequest(get(`${gpi}regulation-categories-list`), thunkAPI)
)

export const GetCurrencies = createAsyncThunk('currencies', (_, thunkAPI) =>
  handleRequest(get(`${gpi}currencies-list`), thunkAPI)
)

export const GetCampusCurrencies = createAsyncThunk('campus-currencies', (_, thunkAPI) =>
  handleRequest(get(`${gpi}campus-currencies-list`), thunkAPI)
)

export const GetAcademicYears = createAsyncThunk('academic-years', (_, thunkAPI) =>
  handleRequest(get(`${gpi}academic-years-list`), thunkAPI)
)

export const GetIntakes = createAsyncThunk('intakes', (_, thunkAPI) =>
  handleRequest(get(`${gpi}intakes-list`), thunkAPI)
)

export const GetOrganizations = createAsyncThunk('organizations', (_, thunkAPI) =>
  handleRequest(get(`${gpi}organizations-list`), thunkAPI)
)

export const GetPublicationFields = createAsyncThunk('publication-fields', (_, thunkAPI) =>
  handleRequest(get(`${gpi}publication-fields-list`), thunkAPI)
)

export const GetPublicationCategories = createAsyncThunk('publication-categories', (_, thunkAPI) =>
  handleRequest(get(`${gpi}publication-categories-list`), thunkAPI)
)

export const GetVideoCategories = createAsyncThunk('video-categories', (_, thunkAPI) =>
  handleRequest(get(`${gpi}video-categories-list`), thunkAPI)
)

export const GetFormTypes = createAsyncThunk('form-types', (_, thunkAPI) =>
  handleRequest(get(`${gpi}form-types-list`), thunkAPI)
)

export const GetBanks = createAsyncThunk('banks', (_, thunkAPI) =>
  handleRequest(get(`${gpi}banks-list`), thunkAPI)
)

export const GetSemesters = createAsyncThunk('semesters', (_, thunkAPI) =>
  handleRequest(get(`${gpi}semesters-list`), thunkAPI)
)

export const GetVideos = createAsyncThunk('videos', (_, thunkAPI) =>
  handleRequest(get(`${gpi}videos-list`), thunkAPI)
)

export const GetStudents = createAsyncThunk('students', (_, thunkAPI) =>
  handleRequest(get(`${gpi}students-list`), thunkAPI)
)

export const Notifications = createAsyncThunk('notifications', (_, thunkAPI) =>
  handleRequest(get(`${gpi}notifications`), thunkAPI)
)

export const ReadNotification = createAsyncThunk('read-notify', (id: string, thunkAPI) =>
  handleRequest(get(`${gpi}read-notification/${id}`), thunkAPI)
)

export const RelatedNotification = createAsyncThunk(
  'related-notification',
  (id: string, thunkAPI) => handleRequest(get(`${gpi}related-notifications/${id}`), thunkAPI)
)

export const GeneralStatistics = createAsyncThunk('gen-stats', (data: {}, thunkAPI) =>
  handleRequest(post(`${gpi}general-statistics`, data), thunkAPI)
)

export const GetTimeSlots = createAsyncThunk('time-slots', (_, thunkAPI) =>
  handleRequest(get(`${gpi}time-slots`), thunkAPI)
)

export const PlanningAcademicYears = createAsyncThunk('planning-ay', (_, thunkAPI) =>
  handleRequest(get(`${gpi}planning-academic-years`), thunkAPI)
)

export const FinanceAcademicYears = createAsyncThunk('finance-ay', (_, thunkAPI) =>
  handleRequest(get(`${gpi}finance-academic-years`), thunkAPI)
)

export const DesiredLevel = createAsyncThunk('desired-level', (_, thunkAPI) =>
  handleRequest(get(`${gpi}desired-level`), thunkAPI)
)

export const GetOnlineProps = createAsyncThunk(
  'online-props',
  ({lang, campusId}: {lang: any; campusId: any}, thunkAPI) =>
    handleRequest(get(`${api}get-props/${lang}/${campusId}`), thunkAPI)
)

export const InactiveStudentAcc = createAsyncThunk('isa', (id: any, thunkAPI) =>
  handleRequest(get(`${api}inactive-account/${id}`), thunkAPI)
)

export const RelatedIntakes = createAsyncThunk('related-intakes', (id: any, thunkAPI) =>
  handleRequest(get(`${api}related-intakes/${id}`), thunkAPI)
)

export const SubmitOnlineApplication = createAsyncThunk('submit-online-app', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}online-app-submit`, data), thunkAPI)
)

export const SubmitKankorApp = createAsyncThunk('submit-kan-app', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}kankor-app-submit`, data), thunkAPI)
)

export const StoreOnlineCourseApp = createAsyncThunk(
  'online-course-app-store',
  (data: {}, thunkAPI) => handleRequest(post(`${api}online-course-app-submit`, data), thunkAPI)
)

export const GetOnlineCourses = createAsyncThunk(
  'get-goc',
  ({lang, cid}: {lang: any; cid: any}, thunkAPI) =>
    handleRequest(post(`${api}get-online-courses/${lang}/${cid}`), thunkAPI)
)

type GeneralState = {
  general: any
  notification: any
}

const initialState: GeneralState = {
  general: [],
  notification: [],
}

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(GetCampuses.fulfilled, (state, action: PayloadAction<any>) => {
      state.general = action.payload
    })
    builder.addCase(Notifications.fulfilled, (state, action: PayloadAction<any>) => {
      state.notification = action.payload
    })
  },
})

export const {reset} = generalSlice.actions
export default generalSlice.reducer
